<template>
  <section class="about-prize">
    <div class="about-prize__wrapper">
      <BaseTitle class="about-prize__title" :text="titleText" :tag="'h2'" />
      <AppSlider :items="prizes" />
    </div>
  </section>
</template>

<script>
import AppSlider from '~/components/AppSlider.vue'

export default {
  computed: {
    titleText() {
      return this.messages.about.aboutPrize.title
    },
    prizes() {
      return this.messages.about.aboutPrize.prizes
    }
  },
  components: {
    AppSlider
  }
}
</script>

<style lang="scss">
.about-prize {
  &__wrapper {
    @include container;

    position: relative;
    padding: 0 16px 100px;

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      bottom: -220px;
      left: -150px;
      width: 452px;
      height: 464px;
      background: url('~/static/img/jury-bg-shape.svg') no-repeat center;
      background-size: cover;
    }
  }

  &__title {
    margin: 0 0 18px;
  }

  .glide {
    &__img {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 231px;
      object-fit: contain;
    }

    &__inner {
      text-align: center;
    }

    &__caption {
      margin: 0 0 10px;
      font-size: 16px;
      line-height: 24px;
    }

    &__text {
      margin: 0;
    }
  }
}

@include media-min($tablet-width) {
  .about-prize {
    &__wrapper {
      padding: 0 25px 100px;

      &::before {
        top: 40px;
        bottom: initial;
        left: -229px;
      }
    }

    &__title {
      margin-bottom: 56px;
    }

    .glide {
      &__caption {
        width: 110%;
        margin-bottom: 20px;
        font-size: 20px;
        line-height: 23px;
      }

      &__img {
        height: 211px;
      }
    }
  }
}

@include media-min($desktop-width) {
  .about-prize {
    &__wrapper {
      padding: 0 65px 149px;

      &::before {
        top: -102px;
        bottom: initial;
        left: -300px;
        width: 2040px;
        height: 824px;
        background: url('~/static/img/about-prize-bg-shape@dt.svg') no-repeat
          center;
        background-size: cover;
      }
    }

    &__title {
      margin-bottom: 56px;
    }

    .glide {
      &__img {
        height: 340px;
        margin-bottom: 40px;
      }

      &__caption {
        width: 100%;
        margin-bottom: 17px;
        padding: 0 40px;
        font-size: 24px;
        line-height: 23px;
      }

      &__text {
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/AboutPrizeBlock.vue